import React, { useState, useContext } from "react"
import Button from "../Button"
import PropTypes from "prop-types"
import Modal, { ModalContent, ModalHeader } from "../Modal"
import ContentCard from "../ContentCard"
import ShareEmail from "../ShareEmail"
import Loading from "../Loading"
import AppContext from "../../shared/AppContext"

import "./share.scss"

const ShareModel = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { trackEvent } = useContext(AppContext)

  const handleShareClick = () => {
    props.onClick()
    setIsModalOpen(!isModalOpen)
    trackEvent("Share Model Button Click", {
      modelName: props.modelName,
      location: props.trackingLocation,
    })
  }

  return (
    <React.Fragment>
      <div
        className="share-button"
        onClick={handleShareClick}
        data-cy="share-button"
      >
        <i className="fas fa-share"></i>
        <span>Share</span>
      </div>
      <Modal isOpen={isModalOpen} close={() => setIsModalOpen(false)}>
        <ModalContent style={{ maxWidth: "500px" }}>
          <ModalHeader
            text="Share The Model"
            close={() => setIsModalOpen(false)}
          />
          <div className="share-container">
            {props.slug ? <ShareEmail slug={props.slug} /> : <Loading />}
            <div className="share-buttons-container">
              <Button
                action={() => setIsModalOpen(!isModalOpen)}
                classes={["share-cancel-button"]}
                text={"Cancel"}
              />
            </div>
          </div>
        </ModalContent>
      </Modal>
    </React.Fragment>
  )
}

ShareModel.propTypes = {
  onClick: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
}

ShareModel.defaultProps = {
  slug: "",
}

export default ShareModel
